import {Component, OnDestroy, OnInit} from '@angular/core';

import {RegistryService} from "../../../../services/registry.service";
import {AuthService} from "../../../../../../services/auth.service";
import {PaymentService} from "../../../../services/payment.service";
import {ActivatedRoute} from "@angular/router";

declare var Checkout;

@Component({
    selector: 'app-payment-mastercard',
    templateUrl: './payment-mastercard.component.html',
    styleUrls: ['./payment-mastercard.component.css']
})
export class PaymentMastercardComponent implements OnInit, OnDestroy {

    userLoggedOutEvent;
    orderId = null;

    payment_button_visibility = false;
    gateway_link = "";

    constructor(public registry: RegistryService,
                private authService: AuthService,
                private paymentService: PaymentService,
                private route: ActivatedRoute
    ) {

    }

    ngOnInit(): void {


        this.route.paramMap.subscribe(paramMap => {
            this.orderId = paramMap.get('orderid');
            let order_id = this.orderId;


            this.paymentService.getMastercardSession(this.orderId).subscribe(result => {

                Checkout.configure({
                    session: {
                        id: result.session_id
                    },
                    interaction: {
                        merchant: {
                            name: "Alarabiya",
                            address: {
                                line1: '200 Sample St',
                                line2: '1234 Example Town'
                            }
                        }
                    },
                    order: {
                        id: order_id,
                        description: "description"
                    }
                });

                Checkout.showPaymentPage();

            });


        })


    }

    ngOnDestroy(): void {
    }

}
